export const loadPinmap = (useCheckout) => {
  if (Math.random() < useCheckout) return true

  return false
}
